import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const Title = styled.div`
  font-family: ${props => props.theme.title.family};
  font-weight: ${props => props.theme.title.weight};
  font-size: ${props => props.theme.title.size};
  color: ${props => props.theme.title.color};
  line-height: ${props => props.theme.title.height};
  margin: ${props => props.theme.title.margin || '0 0 20px'};

  ${breakpoint('mobile')`
      font-size: ${props => props.theme.title.mobile.size};
      line-height: ${props => props.theme.title.mobile.height};
  `};

  ${breakpoint('portrait')`
      font-size: ${props => props.theme.title.portrait.size};
      line-height: ${props => props.theme.title.portrait.height};
  `};
`

export default Title
